import React from 'react';
import { isStripeTestMode } from '../lib/stripe';

/**
 * Displays a banner when Stripe is in test mode
 */
export default function StripeTestBanner() {
  if (!isStripeTestMode) {
    return null;
  }

  return (
    <div className="bg-yellow-600 text-white text-xs md:text-sm py-1 px-3 text-center">
      <span className="inline-flex items-center">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className="h-4 w-4 mr-1" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
          />
        </svg>
        Stripe Test Mode Active - Use card 4242 4242 4242 4242 for testing
      </span>
    </div>
  );
}